<template>
  <AskBidMod v-if="showAskBid" :stock="stock" :context="context" />
</template>
<script>
import AskBidMod from './AskBidMod'
import { mapGetters } from 'vuex'
import { MARKET_TYPE } from 'const/stock'

export default {
  name: 'AskBidPrices',
  components: { AskBidMod },
  props: {
    stock: Object,
    context: String
  },
  computed: {
    ...mapGetters(['hasHkLv2Permission', 'hasUsLv1Permission']),
    showAskBid() {
      if (this.stock.isIndex) return false
      return (
        (this.stock.market === MARKET_TYPE.US && this.hasUsLv1Permission) ||
        (this.stock.market === MARKET_TYPE.HK && this.hasHkLv2Permission)
      )
    }
  }
}
</script>
